import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

import { jsGrid } from "./jsFragmentGrid"
import DceWireEventDetails from "dce-fragments/lib/fragments/dceplugin/DceWireEventDetails";
import {findFragmentParent, Fragment} from "dce-fragments"
import {validateSourceMapOncePerProject} from "ts-loader/dist/utils";

interface GridProps {
    multiSelectAction: string,
    contextMenuAction: string
}

@Dce("GridWithEditor")
export default class GridWithEditor extends DceComponent<GridProps> {

    private element: JQuery<HTMLElement>;

    private grid: jsGrid;

    private selectedChangeCallbacks: ((ids: any[]) => void)[] = [];

    private ctrlPressed = false;

    private selectedEditButton: HTMLElement;
    private selectedEditButtonSeparator: HTMLElement;

    private multiSelectedCells: HTMLElement[] = [];
    private parentFragment: Fragment;

    constructor(elem: DceHTMLElement, props: GridProps | null) {
        super(elem, props);

        this.element = $(elem).first();

        this.grid = new jsGrid(
            this.element,
            props,
            (e: HTMLElement, a:string, t:string, ev: Event) => this.rowClick(e, a, t, ev),
            (elem: HTMLElement, grid:jsGrid, selected: string[], ev: Event) => this.selectedActionClick(elem, grid, selected, ev),
            (e: JQuery.Event) => this.ctrlCellClick(e),
            () => this.highlightSelected(),
            () => this.rebind()
        );

        this.grid.contentReloadedCallback = (data) => {
            if (data['data']['inner-container']) {
                this.createSelectEditElement();
            }
        };

        document.addEventListener("mousewheel", e=> {
            this.MouseWheelHandler(e as MouseEvent);
        }, { passive: false});
        // Firefox
        document.addEventListener("DOMMouseScroll", this.MouseWheelHandler, { passive: false});

        this.createSelectEditElement();

        this.parentFragment = findFragmentParent(elem);

        (this.grid as any).setSelectedChangeCallback((ids:any) => {
            this.selectedChange(ids);
        });

        this.rebind();

        $(document).keydown(event => {
            if (event.which == 17) {
                this.ctrlPressed = true;
                this.element.addClass('grid-highlight-multi-edit-cell');
            }
        })

        $(document).keyup(e=> {
            console.log("KEYUP", e);
            if(!e.originalEvent.ctrlKey){
                this.element.removeClass('grid-highlight-multi-edit-cell');
                this.ctrlPressed = false;
            }
        });

    }

    private MouseWheelHandler(e: MouseEvent){

        // cross-browser wheel delta
        //e = window.event || e;

        if(e.ctrlKey == true){
            e.preventDefault();
        }

        return false;
    }

    private rebind(){

        this.grid.disableMouseClickOnItem = false;

        if(this.element.length == 0){
            return;
        }

        let bodyWrapper = this.element[0].querySelector('.grid-body-wrapper');
        if(!bodyWrapper){
            return;
        }

        bodyWrapper.addEventListener('contextmenu', async (e: PointerEvent) => {

            if(e.target){

                console.log("CCCCCCCCCCCCCCCCCCCC", e);

                let t = e.target as HTMLElement;

                let left = t.offsetLeft + e.offsetX
                let top = t.offsetTop + e.offsetY;


                if(t.tagName != 'TD'){
                    t = t.closest('td');
                }

                if(t.classList.contains('multi-edit-cell')){

                    e.preventDefault();

                    t.classList.add("multi-edit-cell-selected");

                    if(this.multiSelectedCells.indexOf(t) == -1) {
                        this.multiSelectedCells.push(t);
                    }

                    this.refreshSelectedEditButton();

                    this.grid.startLoading();

                    await this.openContextMenu(t, left, top);

                    this.grid.stopLoading();

                    return false;
                }
            }

            console.log('context menu', e);
        });
    }




    openEditorWindow(){
        if(this.multiSelectedCells.length == 0){
            return;
        }

        let data: {
            [key: string]: any;
        } = {};

        for (const cell of this.multiSelectedCells) {

            let eid = cell.dataset['eid']

            if(!data.hasOwnProperty(eid)){
                data[eid] = [];
            }

            let fieldid = cell.dataset['fieldid'];

            data[eid].push(fieldid);

        }

        console.log("DATA", data);

        this.parentFragment.callActionPost(this.props.multiSelectAction, data);

    }

    private contextMenu: HTMLElement = null;

    private hideContextMenu = (e: Event) => {
        console.log("HIDE CONTECT MENU", this);
        this.grid.disableMouseClickOnItem = false;
        this.contextMenu.remove();
        this.elem.removeEventListener('click', this.hideContextMenu);
        this.elem.querySelector('.grid-body-wrapper').removeEventListener('scroll', this.hideContextMenu);
    }

    private removeUpdatedMultiSelectedCells(cells: HTMLElement[]){

        for (const cell of cells) {
            cell.classList.remove("multi-edit-cell-selected");

            let indexOf = this.multiSelectedCells.indexOf(cell);

            if(indexOf > -1){
                this.multiSelectedCells.splice(indexOf, 1);
            }
        }

        this.refreshSelectedEditButton();
    }

    async openContextMenu(clicked: HTMLElement, left: number, top: number){

        if(null != this.contextMenu){
            this.hideContextMenu(null);
        }

        let bodyWrapper = this.elem.querySelector('.grid-body-wrapper');

        let clickedFieldId = clicked.dataset['fieldid'];

        let updatedMultiSelectedCells: HTMLElement[] = [];

        let data: {
            [key: string]: any;
        } = {};

        for (const cell of this.multiSelectedCells) {
            let fieldid = cell.dataset['fieldid'];

            if(fieldid != clickedFieldId){
                continue;
            }

            let eid = cell.dataset['eid']

            if(!data.hasOwnProperty(eid)){
                data[eid] = [];
            }

            data[eid].push(fieldid);
            updatedMultiSelectedCells.push(cell);
        }

        let response = await this.parentFragment.callPost(this.props.contextMenuAction, data);

        let menuHtml = response.getData('menu');

        let tmp = document.createElement('div');
        tmp.innerHTML = menuHtml;

        this.contextMenu = tmp.firstElementChild as HTMLElement;

        bodyWrapper.append(this.contextMenu);

        let contextMenuHeight = this.contextMenu.clientHeight;

        let bottom = bodyWrapper.clientTop + bodyWrapper.clientHeight;

        if((top - bodyWrapper.scrollTop) + contextMenuHeight > bottom){
            top = top - contextMenuHeight;
        }

        this.contextMenu.style.left = left + "px";
        this.contextMenu.style.top = top + "px";

        this.grid.disableMouseClickOnItem = true;

        this.elem.addEventListener('click', this.hideContextMenu);
        bodyWrapper.addEventListener('scroll', this.hideContextMenu);

        this.contextMenu.querySelectorAll('a').forEach(link => {

            link.addEventListener('click', async (e) => {

                let response = await this.parentFragment.callWireAction(link.getAttribute('data-action'));

                console.log(response.data);

                if(response.hasData('rows')){
                    let rows: string = response.getData('rows');

                    this.updateCellsContent(rows);

                    this.removeUpdatedMultiSelectedCells(updatedMultiSelectedCells);

                }

                setTimeout(() => {
                    this.hideContextMenu(null);
                })
            });

        });

        console.log(this.contextMenu);
    }

    private updateCellsContent(rows: string){

        let bodyWrapper = this.elem.querySelector('.grid-body-wrapper');

        let div = document.createElement('div');
        div.innerHTML = rows;

        div.querySelectorAll('td[data-cellid]').forEach(td => {

            console.log("source td", td, td.getAttribute('data-cellid'));

            let cellid = td.getAttribute('data-cellid');

            bodyWrapper.querySelectorAll('td[data-cellid="' + cellid +'"]').forEach(targettd => {
                targettd.innerHTML = td.innerHTML;
            });
        });

    }

    ctrlCellClick(event: JQuery.Event){

        let e = (event as any);

        console.log(event);

        if(e.target && e.target instanceof HTMLElement){
            let target = (e.target as HTMLElement);

            if(target.tagName != 'TD'){
                target = target.closest('td');
            }

            if(!target.classList.contains("multi-edit-cell")){
                return;
            }

            if(target.classList.contains("multi-edit-cell-selected")){
                target.classList.remove("multi-edit-cell-selected");

                let indexOf = this.multiSelectedCells.indexOf(target);

                if(indexOf > -1){
                    this.multiSelectedCells.splice(indexOf, 1);
                }

            }else{
                target.classList.add("multi-edit-cell-selected");
                this.multiSelectedCells.push(target);
            }

            this.refreshSelectedEditButton();

        }
    }



    private refreshSelectedEditButton(){

        if(!this.selectedEditButton){
            return;
        }

        if(this.multiSelectedCells.length > 0){
            this.selectedEditButton.style.display = null;
            this.selectedEditButtonSeparator.style.display = null;
        }else{
            this.selectedEditButton.style.display = 'none';
            this.selectedEditButtonSeparator.style.display = 'none';
        }

    }



    private createSelectEditElement(){

        let button = document.createElement("button");
        button.classList.add("button");
        button.innerText = "Edytuj zaznaczone pola";

        let left = this.elem.querySelector('.grid-toolbar-left');

        let separator = document.createElement('div');
        separator.classList.add("separator");

        left.append(separator);
        left.append(button);

        button.addEventListener('click', e=>{
            this.openEditorWindow();
        });

        this.selectedEditButton = button;
        this.selectedEditButtonSeparator = separator;
        this.refreshSelectedEditButton();
    }


    onSimpleEvent(event: string) {

        if(event == 'saved'){
            this.refresh();
        }

        if(event == 'clearSelected'){
            this.grid.clearSelected();
        }

    }

    public refresh(): void {
        this.grid.refresh();
    }

    public addSelectedChangeCallback(callback: ((ids: any[]) => void)){
        this.selectedChangeCallbacks.push(callback);
    }

    public selectedChange(ids: any[]){
        console.log("-------- SELECTED CHANGE", ids);
        this.selectedChangeCallbacks.forEach(callback => {
            callback(ids);
        });
    }


    //self.actionCallback.call(this, self, self.selected);
    public selectedActionClick(elem: HTMLElement, grid:jsGrid, selected: string[], e: Event){

        let action = elem.dataset['wire'];

        let formData = new FormData();
        selected.forEach((v,s) => {
            formData.append("id[]", v);
        })

        elem.dispatchEvent(new CustomEvent<DceWireEventDetails>("dceWire", {
            bubbles: true,
            detail: {
                type: "click",
                element: elem,
                attr: action,
                originalEvent: e,
                formData: formData
            }
        }));

        // console.log("SELECTED CLICK", elem, grid, selected);
        //
        // if(selected.length == 0){
        //     return;
        // }
        //
        // let button = $(elem);
        //
        // let opdialog = new OpenDialog(elem as DceHTMLElement, {
        //     target: button.data('response-target') ? button.data('response-target') : '#main',
        //     url: elem.getAttribute("href"),
        //     bindClick: false
        // });
        //
        // opdialog.addOnClose((d, e) => {
        //     if (d.dialogIsNextStep || (!d.getFormBind() || (d.getFormBind() && d.getFormSaved()))) {
        //
        //         if (button.data('clearSelected')) {
        //             grid.clearSelected();
        //         }
        //
        //         if(button.data('refresh')){
        //             grid.refresh();
        //         }
        //
        //         this.grid.refresh();
        //     }
        // });
        //
        // let formdata = new FormData();
        // selected.forEach(s => {
        //     formdata.append("ids[]", s);
        // })
        //
        // opdialog.loadDialogWithPost(formdata);

    }

    onSubComponentInit(component: string, elem: DceHTMLElement) {
        super.onSubComponentInit(component, elem);

        //
        // if(component == 'OpenDialog'){
        //     let od = elem.ext.getComponent('OpenDialog') as OpenDialog;
        //     od.addOnSavedClose((o, e) => {
        //         this.grid.refresh();
        //     });
        // }

    }

    public rowClick(elem: HTMLElement, action: string, target: string, e: Event){
        //
        // let opdialog = new OpenDialog(elem as DceHTMLElement, {
        //     target: target,
        //     url: action,
        //     bindClick: false
        // });
        //
        // opdialog.addOnClose((d, e) => {
        //     if (d.dialogIsNextStep || (!d.getFormBind() || (d.getFormBind() && d.getFormSaved()))) {
        //         this.grid.refresh();
        //     }
        // });
        //
        // opdialog.loadDialog();


        elem.dispatchEvent(new CustomEvent<DceWireEventDetails>("dceWire", {
            bubbles: true,
            detail: {
                type: "click",
                element: elem,
                attr: action,
                originalEvent: e
            }
        }));


    }

    private highlightSelected() {
        this.multiSelectedCells = [];
        //this.createSelectEditElement();
        this.refreshSelectedEditButton();
    }
}
